import * as React from "react";
import { cn } from "@/lib/utils";

export type EmptyVariant = "onboarding" | "filtered" | "healthy";
export type EmptySize = "small" | "medium" | "large";

const SIZE: Record<EmptySize, { icon: number; title: string; pad: string }> = {
  small: { icon: 36, title: "text-[14px]", pad: "px-4 py-5" },
  medium: { icon: 48, title: "text-[16px]", pad: "px-6 py-10" },
  large: { icon: 60, title: "text-[20px]", pad: "px-8 py-16" },
};

const ICON_CONTAINER: Record<EmptyVariant, string> = {
  onboarding: "bg-p-50 border border-p-100 text-p-700",
  filtered: "bg-surface-1 border border-line text-ink-500",
  healthy:
    "bg-[color-mix(in_oklab,var(--st-ok-bg)_12%,transparent)] border border-[color-mix(in_oklab,var(--st-ok-bg)_18%,transparent)] text-st-ok-bg",
};

export interface EmptyStateProps {
  variant: EmptyVariant;
  size?: EmptySize;
  icon: React.ReactNode;
  title: string;
  description?: string;
  actions?: React.ReactNode;
  className?: string;
}

export function EmptyState({
  variant,
  size = "medium",
  icon,
  title,
  description,
  actions,
  className,
}: EmptyStateProps) {
  const sz = SIZE[size];
  return (
    <div
      className={cn("mx-auto flex max-w-md flex-col items-center text-center", sz.pad, className)}
    >
      <div
        className={cn("inline-flex items-center justify-center rounded-5", ICON_CONTAINER[variant])}
        style={{ width: sz.icon, height: sz.icon }}
      >
        {icon}
      </div>
      <div
        className={cn("mt-3 font-semibold text-ink-900", sz.title)}
        style={{ fontFamily: "var(--font-display)" }}
      >
        {title}
      </div>
      {description ? <p className="mt-2 max-w-sm text-[13px] text-ink-500">{description}</p> : null}
      {actions ? <div className="mt-4">{actions}</div> : null}
    </div>
  );
}
